import common from '../common';
const { lodash } = common;

export default lodash;
